import api from "../../../api/axios";

// Feature-local wrappers for the Communication endpoints used by the
// /clients/:clientId parent surface.
//
// Endpoints (per backend/app/apps/clients/views.py CommunicationListCreateView):
//   GET  /api/crm/clients/{client_id}/communications/
//          — IsClientAccessible (owner OR share).
//          — Returns CommunicationSerializer payloads ordered by -created_at.
//   POST /api/crm/clients/{client_id}/communications/
//          — get_writable_client_or_403 (owner OR editor share).
//          — Body fields the serializer accepts:
//              type        ("call" | "email" | "message")
//              direction   ("in"   | "out")
//              content     (string, optional)
//          — `created_at` is server-side auto_now_add; `created_by` is
//            the requesting user. Both are read-only on the serializer.
//
// Feature-local copy by convention (Phase S6 — T-3 log-communication
// modal). Stateless request wrappers — no cache, no retry, no
// invalidation. The POST helper is consumed only by
// [[ClientLogCommunicationModal]]; the section's own refresh path
// (ClientActivitySection.handleReload) handles post-success freshness.

export const fetchCommunications = (clientId) =>
  api.get(`/crm/clients/${clientId}/communications/`).then((res) => res.data);

export const postCommunication = (clientId, body) =>
  api
    .post(`/crm/clients/${clientId}/communications/`, body)
    .then((res) => res.data);
